module.exports = __webpack_public_path__ + "static/media/icons_genou.71c79084.svg";